import { ServiceIdForMember } from '@/constants';
import { MODAL_VARIANT_TYPE, ModalVariant } from '@/types/WhenCareModal';

export const getWhenCareModalVariant = (serviceIdForMember: string): ModalVariant => {
  if (serviceIdForMember === ServiceIdForMember.CHILD_CARE_LOCATION) {
    return MODAL_VARIANT_TYPE.CHILDCARE_LOCATION;
  }

  if (
    serviceIdForMember === ServiceIdForMember.PET_CARE ||
    serviceIdForMember === ServiceIdForMember.PET_DAY_CARE_LOCATION ||
    serviceIdForMember === ServiceIdForMember.PET_SITTING_WALKING
  ) {
    return MODAL_VARIANT_TYPE.PET_CARE;
  }

  if (
    serviceIdForMember === ServiceIdForMember.SENIOR_CARE ||
    serviceIdForMember === ServiceIdForMember.HOME_CARE_LOCATION
  ) {
    return MODAL_VARIANT_TYPE.SENIOR_CARE;
  }
  return MODAL_VARIANT_TYPE.DEFAULT;
};
